/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * The currency a price is in.
 */
export const Currency = /* #__PURE__ */ parsers.exactly('eur', 'usd', 'gbp', 'cad');
